/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { NavLink, useHistory } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box
} from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import { Auth } from "aws-amplify";
import athenaLogo from "resources/logo-no-letters-white-border.png";

const useStyles = makeStyles(theme => ({
  root: {
    justifyContent: "space-between"
  },
  menuButton: {
    marginLeft: theme.spacing(2),
    alignSelf: "center"
  },
  logo: {
    width: "125px",
    marginRight: "15px"
  },
  environmentSelector: {
    padding: "5px 10px",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#87b6bd",
      cursor: "pointer"
    },
    "& > svg": {
      marginLeft: "15px"
    }
  },
  capitalize: {
    textTransform: "capitalize"
  },
  navLink: {
    color: "white",
    width: "100%",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    },
    whiteSpace: "nowrap",
    padding: "0 10px"
  },
  activeNavLink: {
    textDecoration: "underline",
    "& > p": {
      fontWeight: "bold"
    }
  }
}));

export default function NavBarComponent() {
  const classes = useStyles();
  const history = useHistory();

  const handleSignOut = () => {
    Auth.signOut().then(() => {
      history.push({ pathname: "/login" });
      localStorage.clear();
    });
  };

  return (
    <AppBar position="sticky">
      <Toolbar className={classes.root}>
        <Box
          component="div"
          display="inherit"
          alignSelf="stretch"
          alignItems="center"
        >
          <NavLink to="/" exact>
            <img className={classes.logo} src={athenaLogo} alt="Athena logo" />
          </NavLink>
          <NavLink
            to="/users"
            className={classes.navLink}
            activeClassName={classes.activeNavLink}
            exact
          >
            <Typography>Users</Typography>
          </NavLink>
          <NavLink
            to="/companies"
            className={classes.navLink}
            activeClassName={classes.activeNavLink}
            exact
          >
            <Typography>Companies</Typography>
          </NavLink>
          <NavLink
            to="/athenaTenants"
            className={classes.navLink}
            activeClassName={classes.activeNavLink}
            exact
          >
            <Typography>Tenants</Typography>
          </NavLink>
          {/* <NavLink
            to="/apolloTenants"
            className={classes.navLink}
            activeClassName={classes.activeNavLink}
            exact
          >
            <Typography>Apollo Tenants</Typography>
          </NavLink> */}
        </Box>
        <Box component="div" display="inherit" alignSelf="stretch">
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={handleSignOut}
          >
            <ExitToApp />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
